export default __webpack_public_path__ + "static/media/streaming.c79ad83f.svg";